import translations from './translations'

translations.add('en', {
    iAgreeToShareWithClickToPay: (cardBrand) => `I agree to share my card details, billing address and email with ${cardBrand || 'Mastercard'} to allow me to securely enroll in Click to Pay for faster checkouts.`,
    learnMore: 'Learn more',
    next: 'NEXT',
    pay: 'PAY',
    submit: 'SUBMIT'
})
